import { ComponentPropsWithRef, useRef } from 'react';
import { Components } from 'react-virtuoso';
import { useSetTopListItemPosition } from 'src/components/Events/EventListing/EventVirtualizedList/useSetTopListItemPosition';
import { VirtuosoContext } from 'src/core/ui/Virtuoso/VirtuosoContext';

export const VirtuosoTopListItemWrapper: Components<
  unknown,
  VirtuosoContext
>['TopItemList'] = ({
  children,
  style,
  context,
}: ComponentPropsWithRef<'div'> & {
  context?: VirtuosoContext;
}) => {
  const topItemListRef = useRef<HTMLDivElement | null>(null);

  useSetTopListItemPosition({
    topItemListRef,
    virtuosoId: context?.virtuosoId ?? '',
  });

  return (
    <div
      ref={topItemListRef}
      style={{ ...style, zIndex: 2 }}
      data-is-top-item={true}
    >
      {context?.topListItemBefore}
      {children}
    </div>
  );
};
